<!--
 * @Description: 首页 - 联系我们
 * @Author: xiehuaqiang
 * @FilePath: /kada-official-web/public/mobile/src/components/m-connect-us/m-connect-us.vue
 * @Date: 2020-12-18 13:54:07
-->
<template>
    <div class='connect-us-cont' :style="blueBg ? 'background: linear-gradient( 310deg, #3398FF 0%, #61C7FF 100%);' : (!whiteBg ? 'background-color: #f6f8fb;' : '')">
        <div class="contact-us light">
            <h2 class="mb-10 fz-18">联系我们</h2>
            <p>电话：400-055-2660</p>
            <p>微信：kadastory01</p>
            <p>邮箱：service@hhdd.com</p>
            <h2 class="mt-10 mb-10 fz-18">品牌、版权、商务合作</h2>
            <p>向老师 xiangtiantian0557@hhdd.com</p>
            <p>杭州红花朵朵网络技术有限公司</p>
        </div>
        <!-- <div class="contact-copyright light">
            <h2 class="mb-10 fz-18">版权合作</h2>
            <p>杨先生</p>
            <p>yb@hhdd.com</p>
            <p>微信：Timboyang</p>
            <h2 class="mt-10 mb-10 fz-18">商务合作</h2>
            <p>杨先生 yb@hhdd.com</p>
            <p>微信：Timboyang</p>
        </div> -->
    </div>
</template>
<script>
export default {
    props: {
        blueBg: {
            type: Boolean,
            default: false
        },
        whiteBg: {
            type: Boolean,
            default: false
        },
    }
}
</script>
<style lang='stylus' scoped>
@import "../../style/vui/mixins"
.connect-us-cont
    // height px2rem2(210)
    padding-bottom px2rem2(8)
    background url('//cdn.hhdd.com/frontend/as/i/4845c6e4-848d-5911-9193-75ec18cce687.png') no-repeat center
    background-size 100% 100%
    background-color #fff
    display flex
    font-size px2rem2(12)
    .contact-us
    .contact-copyright
        padding-top px2rem2(26)
        padding-bottom px2rem2(10)
    .contact-us
        padding-left px2rem2(12)
        line-height px2rem2(18)
    .contact-copyright
        padding-left px2rem2(30)
        line-height px2rem2(18)
</style>



// WEBPACK FOOTER //
// src/components/m-connect-us/m-connect-us.vue